import React from 'react'
import { ErrorModal } from './../../ui'
import { subscriptionHelpers } from '../../../dataHelpers'
import { getStorage, TOKEN_STORAGE_KEY } from '../../../dataHelpers/authenticationHelpers'
import { Button, Form, FormGroup, Input, InputGroup } from 'reactstrap'
import { AppError } from "../../../models"
import Loader from 'react-loader-spinner'
import { NO_VALUE, SELECT_SUBS_PLAN, SUCCESS, DEFAULT_SUBS_PLAN_UPDATE } from '../../../constants'

class SubscriptionDefaultPlan extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: [],
            loading: false,
            subsPlanData: [],
            selectPlanID: '',
            defaultPlanPkId: '',
            defaultPlan: '',
        }
        this.token = (props.token || JSON.parse(getStorage().getItem(TOKEN_STORAGE_KEY)))
        this.submitForm = this.submitForm.bind(this)
        this.dismissError = this.dismissError.bind(this)
        this.fetchSubsPlanList = this.fetchSubsPlanList.bind(this)
        this.handleCheckboxPlan = this.handleCheckboxPlan.bind(this)
    }

    async componentDidMount() {
        if (this.token) {
            this.fetchSubsPlanList()
            this.getDefaultSubscriptionPlan()
        }
    }

    dismissError(error) {
        let errors = this.state.errors.filter((e) => e !== error)
        this.setState({ errors, loading: false })
    }

    async fetchSubsPlanList() {
        let planlistResponse = await subscriptionHelpers.getPlanList(this.token)
        if (!planlistResponse.error) {
            let paidPlanList = planlistResponse.filter(c => ((c.is_seasoned) === true))
            this.setState({ subsPlanData: paidPlanList })
        } else {
            this.setState({ errors: [planlistResponse.error] })
        }
    }

    async getDefaultSubscriptionPlan() {
        try {
            let defaultSubsPlanData = await subscriptionHelpers.getDefaultSubsPlan(this.token)
            if (!defaultSubsPlanData.error) {
                this.setState({ defaultPlanPkId: defaultSubsPlanData[0].id, defaultPlan: defaultSubsPlanData[0].subscriptionPlan.id })
            } else {
                this.setState({ errors: [defaultSubsPlanData.error] })
            }
        } catch (error) {
            console.log(error)
        }
    }

    handleCheckboxPlan(evt) {
        let selectPlanVal = evt.target.value.split(',')
        this.setState({ selectPlanID: selectPlanVal[0], selectPlanIdPkId: selectPlanVal[1] })
    }

    async submitForm(e) {
        e.preventDefault()
        this.setState({ loading: true })
        let { selectPlanID, selectPlanIdPkId } = this.state
        if (!selectPlanID || selectPlanID == '') {
            let appError = new AppError(NO_VALUE, SELECT_SUBS_PLAN)
            await this.setState({ errors: [appError], loading: false })
            return
        }

        let editDefaultPlanResponse = await subscriptionHelpers.editDefaultSubsPlan(this.token, selectPlanID, selectPlanIdPkId)
        if (!editDefaultPlanResponse.error) {
            let appError = new AppError(SUCCESS, DEFAULT_SUBS_PLAN_UPDATE)
            await this.setState({ errors: [appError], loading: false })
            this.getDefaultSubscriptionPlan()
            return
        } else {
            this.setState({ errors: [editDefaultPlanResponse.error] })
        }
    }

    render() {
        let { errors, loading, subsPlanData, defaultPlan, defaultPlanPkId } = this.state
        return (<div>
            <br />
            <br />
            <h1 className="col-12">Default Subscription Plan</h1>
            <br />
            <div className="row justify-content-center align-items-center">
                {loading ?
                    <Loader type="TailSpin" width={60} height={60} /> :
                    <Form onSubmit={this.submitForm} className="col-lg-6 col-md-8 col-sm-10">
                        <FormGroup>
                            <InputGroup>
                                <Input type="select" name="selectPlanID"
                                    onChange={this.handleCheckboxPlan}
                                >
                                    <option value="">&ensp;Select Subscription Plan</option>
                                    {
                                        (subsPlanData ? subsPlanData.map((plandata) => (
                                            <option key={`${plandata.id}`} value={plandata.id + ',' + defaultPlanPkId}
                                                selected={defaultPlan === plandata.id}>&ensp;{plandata.name}</option>
                                        )) : '')
                                    }
                                </Input>
                            </InputGroup>
                            <br />
                        </FormGroup>
                        <Button>Save</Button>
                    </Form>
                }
                {errors.map((appError, idx) =>
                    <ErrorModal key={`error-${appError.text}-${idx}`}
                        modal={true}
                        toggle={() => (this.dismissError(appError))}
                        text={appError.text}
                        title={appError.title} />
                )}
            </div>
        </div>)
    }
}
export default SubscriptionDefaultPlan



// WEBPACK FOOTER //
// ./src/components/pages/subscription/SubscriptionDefaultPlan.js